import React from "react";
import { Form, Input, Button } from "antd";
import { Alert } from "antd";

import {
  valuesAndErrorsToFields,
  validateJsonObject,
  prettyPrintJSONString,
} from "../../shared/util/antdForm";

const LicenseForm = Form.create()(
  class C extends React.Component {
    state = {
      formErrors: undefined,
    };

    handleSubmit = (e) => {
      const { form, onSubmit } = this.props;

      e.preventDefault();
      form.validateFields(async (err, values) => {
        if (err) {
          return;
        }

        const errors = await onSubmit(values);
        if (!errors) {
          return;
        }

        this.setState({ formErrors: errors["_errors"] });
        form.setFields(valuesAndErrorsToFields(values, errors));
      });
    };

    render() {
      const {
        row,
        loading,
        form: { getFieldDecorator },
      } = this.props;

      const { formErrors } = this.state;

      return (
        <Form onSubmit={this.handleSubmit} autoComplete="off" layout="vertical">
          {formErrors && (
            <Form.Item>
              {formErrors.map((error, index) => (
                <Alert
                  key={index}
                  message={error.toString()}
                  type="error"
                  showIcon
                />
              ))}
            </Form.Item>
          )}

          <Form.Item label="Name">
            {getFieldDecorator("name", {
              rules: [{ required: true, message: "Name is required" }],
              validateTrigger: ["onBlur"],
              initialValue: row.name,
            })(<Input type="text" placeholder="Please enter a name" />)}
          </Form.Item>

          <Form.Item label="Settings">
            {getFieldDecorator("settings", {
              rules: [
                {
                  required: true,
                  message: "Settings (even if empty) are required",
                },
                {
                  validator: validateJsonObject,
                  message: "A valid json object is required",
                },
              ],
              validateTrigger: ["onBlur"],
              normalize: (value) => prettyPrintJSONString(value),
              initialValue: prettyPrintJSONString(row.settings || "{}"),
            })(
              <Input.TextArea
                placeholder="Please enter settings as a json object"
                autoSize={{ minRows: 4, maxRows: 15 }}
              />
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save
            </Button>
          </Form.Item>
        </Form>
      );
    }
  }
);

export default LicenseForm;
